import React from "react";
import {
  ListGroup,
  ListGroupItem,
  Button,
  ProgressBar,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import ReactS3Uploader from "react-s3-uploader";
import Alert from "react-s-alert";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";



class ManagePresentation extends React.Component {
  
  constructor() {
    super();

    this.state = {
      progress: 0,
    };
  }

  render() {
    const { props } = this;
    return (
      <Card>
        <Card.Header>
          {props.presentations.length}{" "}
          <FormattedMessage id="heading.files-uploaded-for" /> "
          <b>{props.presentation_name}</b>"
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h4>
                <ReactS3Uploader
                  placeholder="Presentation"
                  className="inputfile"
                  id={`ppt-for-${props.presentation_id}-${props.presentations.length}`}
                  style={{
                    display: "none",
                  }}
                  name={`ppt-for-${props.presentation_id}-${props.presentations.length}`}
                  signingUrl={props.signingUrl}
                  signingUrlMethod="GET" // default "GET"
                  accept=".ppt,.pptx,.pps,.pdf"
                  preprocess={(file, next) => {
                    Alert.warning(
                      props.intl.formatMessage({
                        id: "button.uploadingPresentation",
                      })
                    );
                    next(file);
                  }}
                  onProgress={(progress) => {
                    this.setState({
                      progress,
                    });
                    Alert.warning(`${progress}% uploaded`);
                  }}
                  onError={() => {
                    Alert.error(
                      props.intl.formatMessage({
                        id: "error.file-upload",
                      })
                    );
                  }}
                  onFinish={(url) => {
                    props.addFile(props.presentation_id, url.publicUrl);
                    Alert.success(
                      props.intl.formatMessage({
                        id: "input.presentation.presentationUploaded",
                      })
                    );
                  }} // url.publicUrl
                  signingUrlHeaders={props.signingUrlHeaders}
                  signingUrlQueryParams={props.signingUrlQueryParams}
                  // signingUrlWithCredentials // pass auth creds via CORS
                  uploadRequestHeaders={{
                    "x-amz-acl": "public-read",
                  }}
                  contentDisposition="auto"
                  server={process.env.REACT_APP_API_HOST}
                />
                <label
                  htmlFor={`ppt-for-${props.presentation_id}-${props.presentations.length}`}
                  className="btn btn-primary"
                >
                  <img
                    src="/images/icon-upload-white.png"
                    alt="Upload Presentation"
                    height="24"
                  />
                  <FormattedMessage id="input.presentation.presentationUpload" />
                </label>
              </h4>
            </Col>
            <Col md={6}>
              <br />
              {this.state.progress > 0 && (
                <ProgressBar
                  style={{
                    display: "inline-block",
                    width: "200px",
                  }}
                  now={this.state.progress}
                  label={`${this.state.progress}%`}
                />
              )}
            </Col>
          </Row>

          <ListGroup>
            {props.presentations.map((f) => {
              {console.log("presentation---------------------------------------------------",props.presentations.f)}
              return (
                <ListGroupItem key={f.file}>deleteFile
                  <FormattedMessage id="label.file-uploaded-on" />{" "}
                  {moment(f.date).format("DD/MM/YYYY H:mm")}{" "}
                  <a
                    className="btn btn-sm btn-primary"
                    href={`${process.env.REACT_APP_ASSET_URL}${f.file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/icon-download.png"
                      alt="Download Presentation"
                      height="24"
                    />
                    <FormattedMessage id="link.download" />
                  </a>
                  {props.deleteFile ? (
                    <Button
                      size="small"
                      variant="danger"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        props.deleteFile(
                          f.file,
                          `File uploaded on ${moment(f.date).format(
                            "DD/MM/YYYY h:mm"
                          )}`
                        );
                      }}
                    >
                      {/* <img src="/images/icon-delete.png" alt="Download Presentation" height="24" />&nbsp; */}
                      <FormattedMessage id="button.presentation-delete-file" />
                    </Button>
                  ) : (
                    ""
                  )}
                </ListGroupItem>
              );
            })}
          </ListGroup>
        </Card.Body>
      </Card>
    );
  }
}

// ManagePresentation.propTypes = {
//   intl: intlShape.isRequired,
//   presentation_id: React.PropTypes.string.isRequired
// };

export default injectIntl(ManagePresentation);
